import { isAllowedAvatarUrl } from "@backchannel/tax-contracts";
import { useState } from "react";

/**
 * A small, resilient identity mark shared by the topbar, account menu and
 * account settings. A Cognito/OIDC picture is optional; failed or unsafe
 * images fall back to the same deterministic initial used by the mock.
 */
export function ProfileAvatar({
  name,
  avatarUrl,
  className,
}: {
  name: string;
  avatarUrl?: string | null;
  className: string;
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const initial = name.trim().slice(0, 1).toUpperCase() || "?";
  const showImage = isAllowedAvatarUrl(avatarUrl) && failedUrl !== avatarUrl;

  if (!showImage) {
    return (
      <span className={`${className} ${className}--fallback`} aria-hidden="true">
        {initial}
      </span>
    );
  }

  return (
    <span className={`${className} ${className}--image`} aria-hidden="true">
      <img
        src={avatarUrl}
        alt=""
        loading="lazy"
        decoding="async"
        referrerPolicy="no-referrer"
        onError={() => setFailedUrl(avatarUrl)}
      />
    </span>
  );
}
